import _ from "lodash";
import accountManagement from "./accountManagement";
import departmentManagement from "./departmentManagement";
import organizationManagement from "./organizationManagement";
import adManagement from "./adManagement";
import messageManagement from "./messageManagement";
import feedbackManagement from "./feedbackManagement";
import customerServiceManagement from "./customerServiceManagement";
import routeManagement from "./routeManagement";
import wuMeiManagement from "./wuMeiManagement";

export default _.union(
  accountManagement,
  departmentManagement,
  organizationManagement,
  adManagement,
  messageManagement,
  feedbackManagement,
  customerServiceManagement,
  routeManagement,
  wuMeiManagement,
  [
    {
      name: "platformManagement",
      path: "/platformManagement",
      meta: { title: "平台管理" },
      component: require("views/common/blank.vue").default
    }
  ]
);
